import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

import { useDispatch } from 'react-redux';


import app from '../../utils/Firebase';

import { 
    doc,
    getDoc,
    getFirestore
} from '@firebase/firestore';

import Layout from '../Layout';
import SocialBox from './SocialBox';
import getFullAddress from '../../utils/DataModeling';

import Button from '../../components/Button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { 
    faMapMarkerAlt,
    faPhone,
    faMap,
    faCalendar
} from '@fortawesome/free-solid-svg-icons';

import './index.css';

const db = getFirestore(app);



export default function Restaurant(props){

    const { local_id } = useParams();
    const [ localData, setLocalData ] = useState(null);
    const dispatch = useDispatch();
 
    console.log(props);
    useEffect( () => {
        getLocalData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getLocalData = async () => {
        let docRef = doc(db, 'locales', local_id);
        let docSnapshot = await getDoc(docRef);
        let docData = docSnapshot.data();
        console.log(docData);
        if(docData){
            console.log(docData);
            setLocalData(docData);
            dispatch({type: 'SET_RESTAURANT_DATA', payload: docData})

            localStorage.setItem("local_img", docData.logo);
            document.title = `Encargamelo - ${docData.nombre}`;
        }
        else{
            
            throw new Error("Error al traer datos de restaurante");
        }
    }

    const getSchedule = schedule_obj => {
        let schedule = [];
        let days = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'domingo'];
        for(let day of days){
            let apertura = schedule_obj.horario[day].apertura;
            let cierre = schedule_obj.horario[day].cierre;
            let abierto = schedule_obj.horario[day].abierto;
            
            if(abierto)
                schedule.push(<tr className='schedule-item'><td className='schedule-day'><p>{day}</p></td><td className='schedule-time'><p> { apertura } - { cierre }</p></td></tr>);
            else
                schedule.push(<tr className='schedule-item'><td className='schedule-day'><p>{day}</p></td><td className='schedule-closed'><p>Cerrado</p></td></tr>);
        }
        return schedule;
    }

    let numberOfCols = 0;

    if(localData){
        let contactDataNumber = 0;
        let { facebook, instagram, direccion, telefono } = localData.datos_contacto;
        if(instagram.length > 0)
            contactDataNumber++;

        if(facebook.length > 0)
            contactDataNumber++;

        if(getFullAddress(direccion).length > 0)
            contactDataNumber++
        
        if(telefono.length > 0)
            contactDataNumber++;
        
        numberOfCols = contactDataNumber;
        console.log(contactDataNumber);
    }

    return(
        <Layout local={ local_id }>
            <div className='restaurant__data'>
                { localData ?
                <>
                    <h3 className='restaurant__name'>{ localData.nombre }</h3>

                    <div className='restaurant__schedule'>
                        <h4>Horario</h4>
                        <div className='schedule'>
                            <table className='schedule-container'>
                                { getSchedule(localData) }
                            </table>
                        </div>
                        { getFullAddress(localData.datos_contacto.direccion).length > 0 ? <div><FontAwesomeIcon icon={ faMapMarkerAlt } /> { getFullAddress(localData.datos_contacto.direccion) }</div> : null }
                    </div>

                    <div className='restaurant__buttons' >
                        <Link to={ '/menu/' + local_id }><Button color='secondary' fullWidth={true}><FontAwesomeIcon icon={ faMap }/> Menú</Button></Link>
                        
                        { localData.acepta_reservaciones ? <Link to={ '/reservaciones/' + local_id}><Button color='primary' fullWidth={true}><FontAwesomeIcon icon={ faCalendar }/> Reservaciones</Button></Link> : null }
                    </div>

                    <div className={`restaurant__social-data col-${numberOfCols}`} style={ {marginBottom: '20px'} }>
                        { localData.datos_contacto.facebook.length > 0 ? <SocialBox icon={ <FontAwesomeIcon icon={ faFacebook } />} name='Facebook' link={ localData.datos_contacto.facebook } /> : null }
                        { localData.datos_contacto.instagram.length > 0 ? <SocialBox icon={ <FontAwesomeIcon icon={ faInstagram } />} name='Instagram' link={ localData.datos_contacto.instagram } /> : null }
                        { getFullAddress(localData.datos_contacto.direccion).length > 0 ? <SocialBox icon={ <FontAwesomeIcon icon={ faMapMarkerAlt } />} name='Ubicación' link={ `https://www.google.com/maps/search/?api=1&query=${ encodeURIComponent(getFullAddress( localData.datos_contacto.direccion)) }` } /> : null }
                        { localData.datos_contacto.telefono.length > 0 ? <SocialBox icon={ <FontAwesomeIcon icon={ faPhone } />} name='Telefono' link={'tel:+52'+ localData.datos_contacto.telefono}/> : null }
                    </div>

                </>
                : null}
            </div>
        </Layout>
    );
}

